import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoGraphicSwiper from './components/eco-graphic-swiper';
import { EcoGraphicSwiperItemProps } from './components/eco-graphic-swiper/props';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const learnMoreLists: Record<string, string[]> = {
    eu: [
        'https://eu.ecoflow.com/products/bracket-lattice-balcony',
        'https://eu.ecoflow.com/products/bracket-semi-enclosed-balcony',
        'https://eu.ecoflow.com/products/bracket-concrete-balcony',
        'https://eu.ecoflow.com/products/bracket-flat-roof',
        'https://eu.ecoflow.com/products/bracket-adjustable-facade',
        'https://eu.ecoflow.com/products/bracket-facade',
        'https://eu.ecoflow.com/products/bracket-pitched-roof',
        'https://eu.ecoflow.com/products/bracket-lightweight-facade',
        'https://eu.ecoflow.com/products/bracket-lightweight',
    ],
    uk: [
        'https://uk.ecoflow.com/products/bracket-lattice-balcony',
        'https://uk.ecoflow.com/products/bracket-semi-enclosed-balcony',
        'https://uk.ecoflow.com/products/bracket-concrete-balcony',
        'https://uk.ecoflow.com/products/bracket-flat-roof',
        'https://uk.ecoflow.com/products/bracket-adjustable-facade',
        'https://uk.ecoflow.com/products/bracket-facade',
        'https://uk.ecoflow.com/products/bracket-pitched-roof',
        'https://uk.ecoflow.com/products/bracket-lightweight-facade',
        'https://uk.ecoflow.com/products/bracket-lightweight',
    ],
    es: [
        'https://es.ecoflow.com/products/bracket-lattice-balcony',
        'https://es.ecoflow.com/products/bracket-semi-enclosed-balcony',
        'https://es.ecoflow.com/products/bracket-concrete-balcony',
        'https://es.ecoflow.com/products/bracket-flat-roof',
        'https://es.ecoflow.com/products/bracket-adjustable-facade',
        'https://es.ecoflow.com/products/bracket-facade',
        'https://es.ecoflow.com/products/bracket-pitched-roof',
        'https://es.ecoflow.com/products/bracket-lightweight-facade',
        'https://es.ecoflow.com/products/bracket-lightweight',
    ],
    it: [
        'https://it.ecoflow.com/products/bracket-lattice-balcony',
        'https://it.ecoflow.com/products/bracket-semi-enclosed-balcony',
        'https://it.ecoflow.com/products/bracket-concrete-balcony',
        'https://it.ecoflow.com/products/bracket-flat-roof',
        'https://it.ecoflow.com/products/bracket-adjustable-facade',
        'https://it.ecoflow.com/products/bracket-facade',
        'https://it.ecoflow.com/products/bracket-pitched-roof',
        'https://it.ecoflow.com/products/bracket-lightweight-facade',
        'https://it.ecoflow.com/products/bracket-lightweight',
    ],
    de: [
        'https://de.ecoflow.com/products/bracket-lattice-balcony',
        'https://de.ecoflow.com/products/bracket-semi-enclosed-balcony',
        'https://de.ecoflow.com/products/bracket-concrete-balcony',
        'https://de.ecoflow.com/products/bracket-flat-roof',
        'https://de.ecoflow.com/products/bracket-adjustable-facade',
        'https://de.ecoflow.com/products/bracket-facade',
        'https://de.ecoflow.com/products/bracket-pitched-roof',
        'https://de.ecoflow.com/products/bracket-lightweight-facade',
        'https://de.ecoflow.com/products/bracket-lightweight',
    ],
    fr: [
        'https://fr.ecoflow.com/products/bracket-lattice-balcony',
        'https://fr.ecoflow.com/products/bracket-semi-enclosed-balcony',
        'https://fr.ecoflow.com/products/bracket-concrete-balcony',
        'https://fr.ecoflow.com/products/bracket-flat-roof',
        'https://fr.ecoflow.com/products/bracket-adjustable-facade',
        'https://fr.ecoflow.com/products/bracket-facade',
        'https://fr.ecoflow.com/products/bracket-pitched-roof',
        'https://fr.ecoflow.com/products/bracket-lightweight-facade',
        'https://fr.ecoflow.com/products/bracket-lightweight',
    ],
};

export default function GoodsMore() {
    const { t } = useLang('theProduct.GooadsMore');
    const { locale } = getLocal();

    const text = learnMoreLists[locale] || learnMoreLists.eu;

    const items: EcoGraphicSwiperItemProps[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156535460/list_1.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435098854/p1.jpg',
            title: t('t1'),
            desc: t('d1'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[0],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156538134/list_2.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435101694/p2.jpg',
            title: t('t2'),
            desc: t('d2'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[1],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156558025/list_3.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435104167/p3.jpg',
            title: t('t3'),
            desc: t('d3'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[2],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156560634/list_4.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435107200/p4.jpg',
            title: t('t4'),
            desc: t('d4'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[3],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156594015/list_6.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435112516/p6.jpg',
            title: t('t5'),
            desc: t('d5'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[4],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156563474/list_5.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435109803/p5.jpg',
            title: t('t6'),
            desc: t('d6'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[5],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156596439/list_7.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435117784/p7.jpg',
            title: t('t7'),
            desc: t('d7'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[6],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156598970/list_8.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435120615/p8.jpg',
            title: t('t8'),
            desc: t('d8'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[7],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748156601389/list_9.jpg',
            pcHover: 'https://websiteoss.ecoflow.com/upload/image/1748435123542/p9.jpg',
            title: t('t9'),
            desc: t('d9'),
            cChildren: t('learn_more'),
            cRadius: 'ellipse',
            cTheme: 'blue',
            cType: 'filled',
            cHref: text[8],
        },
    ];

    return (
        <div className={styles.GoodsMore}>
            <EcoSpace />
            <div className="eco-section-common">
                <div className="eco-section">
                    <div className="eco-section-title">{t('title')}</div>
                </div>
            </div>
            <EcoSpaceSmall />
            <EcoGraphicSwiper imgHeight="5-3" items={items} layout="swiper" />
        </div>
    );
}
